(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const initProductReviewRatings = (scope = document) => {
    scope.querySelectorAll('[data-sm-product-review]').forEach((review) => {
      if (review.dataset.ratingReady === 'true') return;

      const input = review.querySelector('input[name="contact[Rating]"]');
      const stars = Array.from(review.querySelectorAll('[data-sm-review-star]'));
      if (!input || stars.length === 0) return;

      const setRating = (rating) => {
        input.value = String(rating);
        stars.forEach((star) => {
          const value = Number(star.dataset.rating);
          star.classList.toggle('is-active', value <= rating);
          star.setAttribute('aria-checked', value === rating ? 'true' : 'false');
        });
      };

      stars.forEach((star) => {
        star.addEventListener('click', () => setRating(Number(star.dataset.rating) || 5));
      });

      setRating(Number(input.value) || 5);
      review.dataset.ratingReady = 'true';
    });

    scope.querySelector('[data-sm-review-success]')?.focus({ preventScroll: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductReviewRatings(), { once: true });
  } else {
    initProductReviewRatings();
  }

  document.addEventListener('shopify:section:load', (event) => initProductReviewRatings(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saintmagic-cart-widget"]) return;
  try {
    
(() => {
  const formatMoney = (cents, currency) => {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency || window.Shopify?.currency?.active || "USD"
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const updateCartWidget = (widget, cart) => {
    const itemCount = Number(cart.item_count || 0);
    const total = formatMoney(cart.total_price, cart.currency);
    const count = widget.querySelector("[data-cart-count]");
    const totalNode = widget.querySelector("[data-cart-total]");
    if (count) count.textContent = String(itemCount);
    if (totalNode) totalNode.textContent = total;
    widget.setAttribute("aria-label", `Open cart: ${itemCount} items, ${total}`);
  };

  const refreshCartWidgets = () => {
    const widgets = Array.from(document.querySelectorAll("[data-cart-widget]"));
    if (!widgets.length) return;
    const root = window.Shopify?.routes?.root || "/";
    window.fetch(`${root}cart.js`, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw new Error("Cart request failed");
        return response.json();
      })
      .then((cart) => {
        widgets.forEach((widget) => updateCartWidget(widget, cart));
      })
      .catch(() => {
      });
  };

  const scheduleRefresh = () => {
    window.setTimeout(refreshCartWidgets, 450);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshCartWidgets);
  } else {
    refreshCartWidgets();
  }

  window.addEventListener("pageshow", refreshCartWidgets);
  document.addEventListener("cart:refresh", refreshCartWidgets);
  document.addEventListener("saintmagic:cart-refresh", refreshCartWidgets);

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute("action") || "").includes("/cart/add")) scheduleRefresh();
  });

  if (!window.__saintmagicCartFetchPatched) {
    const nativeFetch = window.fetch;
    window.fetch = function patchedFetch(...args) {
      const request = args[0];
      const url = typeof request === "string" ? request : request?.url || "";
      const response = nativeFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        response.then(scheduleRefresh).catch(() => {
        });
      }
      return response;
    };
    window.__saintmagicCartFetchPatched = true;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
